
import { makeStyles } from 'tss-react/mui';

export type PsychiatryStyleProps = {
  isDrawer: boolean;
};

export const useStyles = makeStyles<PsychiatryStyleProps>()((theme, { isDrawer }) => ({
  appBar: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.getContrastText(theme.palette.common.white),
    height: '65px',
    width: '424px',
    borderRadius: '4px',
    right: 'auto !important'
  },
  accepts: {
    textDecoration: 'underline',
    textDecorationColor: theme.palette.success.main,
    textTransform: 'uppercase'
  },
  acceptsBlock: {
    color: theme.palette.legacyPrimary.dark,
    fontSize: '.875rem',
    fontWeight: 600,
  },
  backButton: {
    fontSize: '14px',
  },
  container: (() => {
    if (isDrawer) {
      return {};
    } else {
      return {
        [theme.breakpoints.up('sm')]: {
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)',
          width: '100%'
        }
      };
    }
  })(),
  fullWidth: {
    gridColumn: '1 / span 12',
    marginTop: theme.spacing(4),
  },
  halfWidth: {
    gridColumn: '4 / span 3',
    marginTop: theme.spacing(4),
    padding: theme.spacing(0, 3),
  },
  icon: {
    color: theme.palette.lightGold.main,
    height: '29px',
    marginBottom: theme.spacing(3),
    width: '26px',
  },
  mainPanel: {
    padding: 0,
    margin: 0,
  },
  mb: {
    marginBottom: theme.spacing(5),
  },
  profile: {
    display: 'flex',
    flexDirection: isDrawer ? 'column' : 'row',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: isDrawer ? 0 : theme.spacing(15),
  },
  startIcon: {
    color: theme.palette.lightGold.main,
    height: isDrawer ? '50px' : '29px',
    marginBottom: theme.spacing(3),
    width: isDrawer ? '45px' : '26px',
  },
  toolbarTitle: {
    flexGrow: 1
  }
}));
